import { SET_AWARD } from "./SectionTwoAction";

const initialState = {
  award: [],
};

const sectionTwoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AWARD:
      return {
        ...state,
        award: action.payload,
      };

    default:
      return state;
  }
};

export default sectionTwoReducer;
